import uniq from 'lodash/uniq';
import { createActions, createConsts } from '../../utils/redux';

export const DEFAULT_LIMIT = 20;
export const DEFAULT_OFFSET = 0;

const supportedActions = [
  'SET_LAST_USER_ID',
  'REMOVE_LAST_USER_ID',
  'UPDATE_LAST_USER_ID',

  'SET_LAST_SOCIAL_ID',
  'REMOVE_LAST_SOCIAL_ID',
  // pagination
  'SET_OFFSET',

  // action handlers
  'ADD_EXCLUDED_ID',
  'CLEAR_EXCLUDED_IDS',
  'LOAD_NEXT_PAGE',
  'CLEAR_CHAT_ID',

  // common
  'CLEAR',
];

export const consts = createConsts('board', 'settings', ...supportedActions);
export const actions = createActions(consts);

export const initialState = {
  lastUserId: null,
  limit: DEFAULT_LIMIT,
  offset: DEFAULT_OFFSET,
  excludedIds: [],
};

const setLastSocialId = (state, action) => {
  const { id } = action.payload;

  return {
    ...state,
    lastSocialId: id,
  };
};

const removeLastSocialId = (state, action) => {
  return {
    ...state,
    lastSocialId: null,
  };
};

const setLastUserId = (state, action) => {
  const { id } = action.payload;

  return {
    ...state,
    lastUserId: id,
  };
};

const removeLastUserId = (state, action) => {
  return {
    ...state,
    lastUserId: null,
  };
};

const clearChatId = (state, action) => {
  return {
    ...state,
    lastSocialId: null,
    lastUserId: null,
  };
};

const setOffset = (state, action) => {
  return {
    ...state,
    offset: action.payload,
  };
};

const addExcludedId = (state, action) => {
  const excludedIds = uniq([...state.excludedIds, action.payload]);

  return {
    ...state,
    excludedIds,
  };
};

const clearExcludedId = (state, action) => {
  return {
    ...state,
    excludedIds: [],
  };
};

const loadNextPage = (state, action) => {
  const { limit, offset } = state;

  return {
    ...state,
    offset: offset + limit,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case consts.SET_LAST_USER_ID:
      return setLastUserId(state, action);
    case consts.REMOVE_LAST_USER_ID:
      return removeLastUserId(state, action);
    case consts.SET_LAST_SOCIAL_ID:
      return setLastSocialId(state, action);
    case consts.REMOVE_LAST_SOCIAL_ID:
      return removeLastSocialId(state, action);
    case consts.SET_OFFSET:
      return setOffset(state, action);
    case consts.ADD_EXCLUDED_ID:
      return addExcludedId(state, action);
    case consts.CLEAR_EXCLUDED_ID:
      return clearExcludedId(state, action);
    case consts.LOAD_NEXT_PAGE:
      return loadNextPage(state, action);
    case consts.CLEAR_CHAT_ID:
      return clearChatId(state, action);
    case consts.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/board/settings.js